enum AssetAllocationType {
  EQUITY = 'EQUITY',
  BONDS = 'BONDS',
  UNDEFINED = 'UNDEFINED',
}

export default AssetAllocationType;
